import { HashRouter, useLocation } from "react-router-dom";
import Footer from "./components/footer";
import Broutes from "./routes";
import { ThemeProvider, CssBaseline, Box, Hidden } from "@mui/material";
import { darkTheme, lightTheme } from "./themes";
import Loader from "./components/loader";
import AppToast from "./components/toast";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Device from "./components/device";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { themeReq } from "./store/slices/authSlice";

function App() {
  const dispatch = useDispatch()
  const theme = useSelector((state: any) => state.auth.theme);
  useEffect(() => {
    const theme = localStorage.getItem("theme");
    dispatch(themeReq(theme));
  }, [dispatch]);

  return (
    <HashRouter>
      <AppContent theme={theme} />
    </HashRouter>
  );
}

function AppContent({ theme }: { theme: string }) {
  const location = useLocation();
  const showFooter = location.pathname === "/contact" || location.pathname === "/contact/";

  return (
    <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CssBaseline />
        <Hidden mdDown>
          <Box sx={{ height: "50px" }} />
        </Hidden>
        <Broutes />
        {showFooter && <Footer />}
        <AppToast />
        <Loader />
        <Device />
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
